( function ( _s ) {
	_s.fn.openVideoModal = function () {
		return this.each( el => {
			const _self = _s( el );
			const _modalTpl = _s( '#fr-video-modal' );

			_self.on( 'click', event => {
				if ( ! event.target.closest( '[fr-open-video-modal]' ) ) return;

				const _el = _s( event.target.closest( '[fr-open-video-modal]' ) );
				const templateClone = _modalTpl.el[ 0 ].content.cloneNode( true );
				//random id to identify modal on the dom
				const modalId = 'modal_' + Math.random().toString( 16 ).slice( 2 );

				//add a random id
				templateClone.querySelector( '.video-modal' ).id = modalId;

				// Append the cloned template to the body
				document.body.appendChild( templateClone );

				//destroy on close
				_s( `#${ modalId }` ).on( 'hidden.bs.modal', ev => {
					_s( `#${ modalId }` ).remove();
				} );

				//on modal shown add the content
				_s( `#${ modalId }` ).on( 'shown.bs.modal', ev => {
					_s( `#${ modalId } .modal-body` ).html(
						JSON.parse( _el.attr( 'fr-open-video-modal' ) ).content
					);
				} );

				//open modal
				new window.bs.Modal( _s( `#${ modalId }` ).el[ 0 ] ).show();
			} );
		} );
	};

	_s( document ).ready( () => {
		_s( 'body' ).openVideoModal();
	} );
} )( window._s );
